<template>
  <div class="header">
    <div class="div1">
      <div class="divs"></div>
    </div>
    <div class="right">
      <el-select
        :value="storeId"
        @change="setStoreId"
        placeholder="请选择门店"
        v-if="list && list.length > 0"
      >
        <el-option
          :label="item.storeName"
          :value="item.storeId"
          v-for="item in list"
          :key="item.storeId"
        ></el-option>
      </el-select>
      <div class="theme-button"><ToggleTheme /></div>
      <!--   <div class="bell"><i class="fa fa-bell-o"></i></div> -->
      <div class="user">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            用户名<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!--    <el-dropdown-item><i class="fa fa-user-circle-o"></i>账号设置</el-dropdown-item>
                        <el-dropdown-item><i class="fa fa-lock"></i>安全设置</el-dropdown-item> -->
            <el-dropdown-item @click.native="quit"
              ><i class="fa fa-power-off"></i>退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!--    <div class="language">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        简体中文<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>简体中文</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div> -->
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from "../utils/setToken";
import ToggleTheme from "./ToggleTheme.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "Header2",
  components: { ToggleTheme },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("common", ["storeId"]),
    list() {
      // 计算逻辑
      let storeList = localStorage.getItem("storeList");
      if (storeList) {
        storeList = JSON.parse(storeList);
      }
      return storeList || [];
    },
  },
  methods: {
    ...mapMutations("common", ["setStoreId"]),
    quit() {
      this.$router.replace("/pcLogin");
      removeToken("token");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.header {
  height: 80px;
  position: relative;
  background-color: var(--bg-color);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  font-size: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .theme-button {
    margin-right: 10px;
  }

  .div1 {
    height: 80px;
    margin-left: 20px;
    display: flex;
    align-items: center;

    .divs {
      width: 212px;
      height: 28px;
      border-radius: 5px;
      background: var(--logo-img);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    .divss {
      margin-left: 15px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 19px;
      color: var(--text-color4);
    }
  }

  .right {
    height: 80px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .bell {
    font-size: 14px;
    margin-bottom: 4px;
  }

  .user {
    margin: 0 15px;
  }

  .language {
    margin-right: 50px;
  }
}
</style>
